var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedulerTableArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 7 12",
    width: 7,
    height: 12,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    fill: "#587e85",
    fillRule: "evenodd",
    d: "M 0.21967 11.2803 C 0.485936 11.5466 0.9026 11.5708 1.19621 11.3529 L 1.28033 11.2803 L 6.28033 6.28033 C 6.5466 6.01406 6.5708 5.5974 6.35295 5.30379 L 6.28033 5.21967 L 1.28033 0.21967 C 0.987437 -0.0732231 0.512563 -0.0732231 0.21967 0.21967 C -0.0465966 0.485937 -0.0708027 0.9026 0.147052 1.19621 L 0.21967 1.28033 L 4.689 5.75 L 0.21967 10.2197 C -0.0465966 10.4859 -0.0708027 10.9026 0.147052 11.1962 L 0.21967 11.2803 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulerTableArrowLeft);
export default __webpack_public_path__ + "static/media/scheduler-table-arrow-left.3fb466551feefd19a4351c66ae3c6911.svg";
export { ForwardRef as ReactComponent };